import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { FaBars, FaTimes } from 'react-icons/fa'
import logo from '../Image/logo.png'
import { IoIosArrowDown } from 'react-icons/io'
import Runing_bar from './Runing_bar'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { TiArrowRight } from 'react-icons/ti'

function Main_Navbar() {
  const navRef = useRef()
  const [activeLink, setActiveLink] = useState('/')
  const [showProgramDropdown, setShowProgramDropdown] = useState(false)
  const [showCareersDropdown, setShowCareersDropdown] = useState(false)
  const [showSubDropdown, setShowSubDropdown] = useState({
    program1: false,
    program2: false,
    program3: false,
  })

  const showNavbar = () => {
    if (navRef.current) {
      navRef.current.classList.toggle('responsive_nav')
    }
  }

  const handleLinkClick = (path) => {
    setActiveLink(path)
    showNavbar()
  }

  return (
    <div className="top_bar_fix">
      <div>
        <Runing_bar />
      </div>
      <header className="pb-2">
        <Link to="/">
          <img
            className="Mobile_logo px-2 d-sm-block d-md-none"
            src={logo}
            alt="InternsElite Logo"
          />
        </Link>
        <Link to="/">
          <img
            className="Tab_logo px-2 d-none d-md-block d-xl-none"
            src={logo}
            alt="InternsElite Logo"
          />
        </Link>
        <Link to="/">
          <img
            className="logo px-5 pt-2 d-none d-xl-block d-md-none"
            src={logo}
            alt="InternsElite Logo"
          />
        </Link>
        <nav ref={navRef} className="pt-2">
          <li
            className={`px-1 nav-link-wrapper ${activeLink === '/' ? 'active' : ''
              }`}
          >
            <Link
              className="nav-link text-dark"
              to="/"
              onClick={() => handleLinkClick('/')}
            >
              Home
            </Link>
          </li>
          <li
            className={`px-1 nav-link-wrapper ${activeLink === '/About-Internselite' ? 'active' : ''
              }`}
          >
            <Link
              className="nav-link text-dark"
              to="/About-Internselite"
              onClick={() => handleLinkClick('/About-Internselite')}
            >
              About
            </Link>
          </li>
          <li
            className={`px-1 nav-link-wrapper d-md-block d-xl-none ${activeLink === '/Training-Programs' ? 'active' : ''
              }`}
          >
            <Link
              className="nav-link text-dark"
              to="/Training-Programs"
              onClick={() => handleLinkClick('/Training-Programs')}
            >
              Program
            </Link>
          </li>
          <li
            className={`px-1 nav-link-wrapper d-md-block d-xl-none ${activeLink === '/Careers' ? 'active' : ''
              }`}
          >
            <Link
              className="nav-link text-dark"
              to="/Careers"
              onClick={() => handleLinkClick('/Careers')}
            >
              Careers
            </Link>
          </li>
          <li
            className={`px-1 nav-link-wrapper d-none d-xl-block d-md-none ${activeLink === '/Training-Programs' ? 'active' : ''
              }`}
            onMouseEnter={() => setShowProgramDropdown(true)}
            onMouseLeave={() => setShowProgramDropdown(false)}
          >
          <Link className="nav-link text-dark" to="" onClick={() => handleLinkClick('')}>Program <IoIosArrowDown /></Link>
            {showProgramDropdown && (
              <ul className="dropdown-menu py-3">
                <li
                  className="dropdown-item"
                  onMouseEnter={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program1: true }))
                  }
                  onMouseLeave={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program1: false }))
                  }
                >
                  <Link className="dropdown-link">
                    <div className="row">
                      <div className="col-10">Traineeship Program</div>
                      <div className="col-2">
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                  </Link>
                  {showSubDropdown.program1 && (
                    <ul className="sub-dropdown-menu py-3">
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Artificial-Intelligence"
                          onClick={() =>
                            handleLinkClick('/Artificial-Intelligence')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                              Artificial Intelligence
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Machine-Learning"
                          onClick={() => handleLinkClick('/Machine-Learning')}
                        >
                          <div className="row">
                            <div className="col-10">Machine Learning</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Web-Development"
                          onClick={() => handleLinkClick('/Web-Development')}
                        >
                          <div className="row">
                            <div className="col-10">Web Development</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Data-Science"
                          onClick={() => handleLinkClick('/Data-Science')}
                        >
                          <div className="row">
                            <div className="col-10">Data Science</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Android-App-Development"
                          onClick={() =>
                            handleLinkClick('/Android-App-Development')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                              Android App Development
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Robotics"
                          onClick={() => handleLinkClick('/Robotics')}
                        >
                          <div className="row">
                            <div className="col-10">Robotics</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Cyber-Security"
                          onClick={() => handleLinkClick('/Cyber-Security')}
                        >
                          <div className="row">
                            <div className="col-10">Cyber Security</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Cloud-Computing"
                          onClick={() => handleLinkClick('/Cloud-Computing')}
                        >
                          <div className="row">
                            <div className="col-10">Cloud Computing</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Human-Resources"
                          onClick={() => handleLinkClick('/Human-Resources')}
                        >
                          <div className="row">
                            <div className="col-10">Human Resource</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Finance"
                          onClick={() => handleLinkClick('/Finance')}
                        >
                          <div className="row">
                            <div className="col-10">Finance</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Business-Analytics"
                          onClick={() => handleLinkClick('/Business-Analytics')}
                        >
                          <div className="row">
                            <div className="col-10">Business Analytics</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Autocad"
                          onClick={() => handleLinkClick('/Autocad')}
                        >
                          <div className="row">
                            <div className="col-10">AutoCAD</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Digital-Marketing"
                          onClick={() => handleLinkClick('/Digital-Marketing')}
                        >
                          <div className="row">
                            <div className="col-10">Digital Marketing </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Vlsi-Design"
                          onClick={() => handleLinkClick('/Vlsi-Design')}
                        >
                          <div className="row">
                            <div className="col-10">VLSI</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Internet-Of-Things"
                          onClick={() => handleLinkClick('/Internet-Of-Things')}
                        >
                          <div className="row">
                            <div className="col-10">Internet of Things</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Embedded-System"
                          onClick={() => handleLinkClick('/Embedded-System')}
                        >
                          <div className="row">
                            <div className="col-10">Embedded System</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  className="dropdown-item my-2"
                  onMouseEnter={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program2: true }))
                  }
                  onMouseLeave={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program2: false }))
                  }
                >
                  <Link className="dropdown-link">
                    <div className="row">
                      <div className="col-10">Advance Programs</div>
                      <div className="col-2">
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                  </Link>
                  {showSubDropdown.program2 && (
                    <ul className="sub-dropdown-menu py-2">
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Java-Programming"
                          onClick={() => handleLinkClick('/Java-Programming')}
                        ></Link>
                      </li>
                      <li className="mb-2">
                        <Link
                          className="dropdown-item"
                          to="/Python-Programming"
                          onClick={() => handleLinkClick('/Python-Programming')}
                        >
                          <div className="row">
                            <div className="col-10">Python Programming</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Digital-Marketing-and-Marketing"
                          onClick={() =>
                            handleLinkClick('/Digital-Marketing-and-Marketing')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                              Digital Marketing & Marketing
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-2">
                        <Link
                          className="dropdown-item"
                          to="/Full-Stack-Web-Development"
                          onClick={() =>
                            handleLinkClick('/Full-Stack-Web-Development')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                              Full Stack Web Development
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Mern-Stack-Development"
                          onClick={() =>
                            handleLinkClick('/Mern-Stack-Development')
                          }
                        >
                          <div className="row">
                            <div className="col-10">Mern Stack Development</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="mt-2">
                        <Link
                          className="dropdown-item"
                          to="/C-CPP-DSA"
                          onClick={() => handleLinkClick('/C-CPP-DSA')}
                        >
                          <div className="row">
                            <div className="col-10">DSA with C, C++</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li className="dropdown-item">
                  <Link
                    to="/Double-Program"
                    onClick={() => handleLinkClick('/Double-Program')}
                    className="dropdown-link"
                  >
                    <div className="row">
                      <div className="col-10">Combo Program</div>
                      <div className="col-2">
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                  </Link>
                </li>
                {/* <li className="dropdown-item my-2">
                  <Link
                    to="/Coding-Skill-Program"
                    onClick={() => handleLinkClick('/Coding-Skill-Program')}
                    className="dropdown-link"
                  >
                    <div className="row">
                      <div className="col-10">Coding Skill Program</div>
                      <div className="col-2">
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                  </Link>
                </li> */}
              </ul>
            )}
          </li>
          <li
            className={`px-1 nav-link-wrapper d-none d-xl-block d-md-none ${activeLink === '/Careers' ? 'active' : ''
              }`}
            onMouseEnter={() => setShowCareersDropdown(true)}
            onMouseLeave={() => setShowCareersDropdown(false)}
          >
            <Link
              className="nav-link text-dark"
              to=""
              onClick={() => handleLinkClick('')}
            >
              Careers <IoIosArrowDown />
            </Link>
            {showCareersDropdown && (
              <ul className="dropdown-menu py-3">
                <li>
                  <Link
                    className="dropdown-item"
                    to="/Campus-Ambassador-Program"
                    onClick={() =>
                      handleLinkClick('/Campus-Ambassador-Program')
                    }
                  >
                    <div className="row">
                      <div className="col-12">
                        Become InternsElite’s Campus Ambassador
                      </div>
                    </div>
                  </Link>
                </li>
                <li className="my-2">
                  <Link
                    className="dropdown-item"
                    to="/Business-Development-Associate"
                    onClick={() =>
                      handleLinkClick('/Business-Development-Associate')
                    }
                  >
                    <div className="row">
                      <div className="col-12">Looking For A Job ?</div>
                    </div>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li
            className={`px-1 nav-link-wrapper ${activeLink === '/Contact-Us' ? 'active' : ''
              }`}
          >
            <Link
              className="nav-link text-dark"
              to="/Contact-Us"
              onClick={() => handleLinkClick('/Contact-Us')}
            >
              Contact
            </Link>
          </li>
          <li className="nav-link-wrapper">
            <Link to="/Student-Register">
              <button
                className="shadow-sm mx-4 px-5 pt-2 pb-2 Navbar_button"
                onClick={() => handleLinkClick('/Student-Register')}
              >
                Register
              </button>
            </Link>
          </li>
          <button className="nav-btn nav-close-btn" onClick={showNavbar}>
            <FaTimes />
          </button>
        </nav>
        <button className="nav-btn" onClick={showNavbar}>
          <FaBars />
        </button>
      </header>
    </div>
  )
}

export default Main_Navbar
